"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTableCell = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.StyledTableCell = styled_components_1.default.td `
  font: ${config_1.fontSizes.small} ${config_1.fontFamilies.primary};
  height: 60px;
  padding: ${(props) => props.padding ? props.padding : '16px'} !important;
  width: ${(props) => (props.width ? props.width : '20%')};
`;
